import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube, Music2, MapPin, Phone, Mail, Globe } from 'lucide-react';
import { LOGO_DARK_BG } from '../../lib/constants';
import { useSiteConfig } from '../../lib/siteConfig';

const COLUMNS = [
  {
    title: 'Enlaces',
    links: [
      { label: 'Inicio', to: '/' },
      { label: 'Nosotros', to: '/nosotros' },
      { label: 'Beneficios', to: '/beneficios' },
      { label: 'Membresías', to: '/membresias' },
      { label: 'Capacitación', to: '/capacitacion' },
      { label: 'Noticias', to: '/noticias' },
      { label: 'Contacto', to: '/contacto' },
    ],
  },
  {
    title: 'Módulos',
    links: [
      { label: 'Feed profesional', to: '/beneficios' },
      { label: 'Mapa colaborativo', to: '/beneficios' },
      { label: 'Chat IA', to: '/beneficios' },
      { label: 'Micrositio', to: '/beneficios' },
      { label: 'Mis propiedades', to: '/beneficios' },
      { label: 'Más módulos', to: '/beneficios' },
    ],
  },
  {
    title: 'Recursos',
    links: [
      { label: 'Biblioteca legal', to: '/beneficios' },
      { label: 'Observatorio', to: '/beneficios' },
      { label: 'Eventos', to: '/capacitacion' },
      { label: 'Blog', to: '/noticias' },
      { label: 'Preguntas frecuentes', to: '/contacto' },
      { label: 'Soporte', to: '/contacto' },
    ],
  },
];

export default function Footer() {
  const cfg = useSiteConfig();
  const contact = cfg.footer || {};
  const social = cfg.social || {};
  const SOCIALS = [
    { icon: Facebook, label: 'Facebook', url: social.facebook },
    { icon: Instagram, label: 'Instagram', url: social.instagram },
    { icon: Linkedin, label: 'LinkedIn', url: social.linkedin },
    { icon: Music2, label: 'TikTok', url: social.tiktok },
    { icon: Youtube, label: 'YouTube', url: social.youtube },
  ].filter((s) => s.url);
  return (
    <footer className="bg-cnib-navydeep text-slate-300" data-testid="footer-container">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <img src={LOGO_DARK_BG} alt="CNIB" className="h-12 w-auto" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">{contact.about}</p>
            {SOCIALS.length > 0 && (
              <div className="mt-6 flex gap-3">
                {SOCIALS.map(({ icon: Icon, label, url }) => (
                  <a
                    key={label}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    data-testid={`footer-social-${label.toLowerCase()}`}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-all duration-300 hover:border-orange-500 hover:bg-orange-500 hover:text-white"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                ))}
              </div>
            )}
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-white">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-slate-400 transition-colors hover:text-orange-400">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 grid gap-4 border-t border-white/10 pt-8 text-sm text-slate-400 md:grid-cols-2">
          <div className="space-y-2">
            <p className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-orange-500" /> {contact.address}
            </p>
            <p className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-orange-500" /> {contact.phone}
            </p>
          </div>
          <div className="space-y-2 md:text-right">
            <p className="flex items-center gap-2 md:justify-end">
              <Mail className="h-4 w-4 text-orange-500" /> {contact.email}
            </p>
            <p className="flex items-center gap-2 md:justify-end">
              <Globe className="h-4 w-4 text-orange-500" /> {contact.web}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 text-xs text-slate-500 sm:px-6 md:flex-row lg:px-8">
          <p>© 2026 CNIB - Cámara Nacional Inmobiliaria de Bolivia. Todos los derechos reservados.</p>
          <p>Conectando hoy un mejor futuro inmobiliario para Bolivia.</p>
        </div>
      </div>
    </footer>
  );
}
